import { render, staticRenderFns } from "./teacherScoreInfo.vue?vue&type=template&id=08d2fa72&scoped=true"
import script from "./teacherScoreInfo.vue?vue&type=script&lang=js"
export * from "./teacherScoreInfo.vue?vue&type=script&lang=js"
import style0 from "./teacherScoreInfo.vue?vue&type=style&index=0&id=08d2fa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2fa72",
  null
  
)

export default component.exports